const stringifyStreetAddressLines = (streetAddressLines) => {
  if (streetAddressLines === undefined) {
    return '';
  } else if (typeof streetAddressLines === 'string') {
    return streetAddressLines.concat(',');
  } else {
    return streetAddressLines.filter(Boolean).join(', ').concat(',');
  }
};

const formatPropertyAddress = ({ streetAddressLines, suburb, state, country }) => {
  const sanitisedAddress = [stringifyStreetAddressLines(streetAddressLines), suburb, state, country].filter(Boolean);
  return sanitisedAddress.join(' ');
};

export default formatPropertyAddress;
